import type { TourStep } from '../types';

export const settingUpProfileSteps: TourStep[] = [
  {
    target: '[data-tour="profile-section"]',
    title: 'Your Appraiser Profile',
    content:
      'Everything here feeds into your public website, engagement letters, and report certifications. Let\'s set it up.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="profile-photo"]',
    title: 'Upload a Headshot',
    content:
      'A professional photo appears on your public website and team directory. Click the upload area to add one — square crops work best.',
    placement: 'right',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ll add one later',
  },
  {
    target: '[data-tour="profile-bio"]',
    title: 'Write Your Bio',
    content:
      'A short professional summary and your credentials (SRA, MAI, etc.). This shows on your public website and helps clients understand your qualifications. Try typing a few sentences.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve written something',
  },
  {
    target: '[data-tour="profile-contact"]',
    title: 'Add Contact Info',
    content:
      'Your business phone, office address, and alternate emails. These populate engagement letters and your public listing automatically.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'Done',
  },
  {
    target: '[data-tour="profile-license"]',
    title: 'Enter Your License',
    content:
      'Your NJ appraiser license number and expiration date. This is required for account verification and auto-fills on your report certifications.',
    placement: 'bottom',
    isActionStep: true,
    spotlightClicks: true,
    nextButtonText: 'I\'ve entered it',
  },
  {
    target: '[data-tour="profile-firm"]',
    title: 'Firm Information',
    content:
      'If you operate under a firm, add the company name, address, and EIN. This populates the firm fields in your appraisal reports automatically.',
    placement: 'bottom',
    spotlightClicks: true,
  },
];
